
import {map} from 'rxjs/operators';
import { Component, Inject } from '@angular/core';
import { SIDE_EFFECT_DATA_TOKEN, SideEffectData } from '../models/types';
import { GroupService } from '../../../../../admin/services/group.service';
import { Group } from '../../../../../admin/models/group.model';
import { Rule } from '../../../../../common/models/flow.dto';
import { genId } from '../../../../../core/services/genId';
import { SystemNotificationLevel } from '../../../../../notifications/system-notifications/models/system-notification.model';
import { DomainValue } from '../../../../../common/models/document-tag.model';
import { Observable } from 'rxjs';
import { DomainDefinitionService } from '../../../../services/domain-definition.service';

@Component({
    selector: 'side-effect-send-notification',
    templateUrl: './side-effect-send-notification.component.html',
    styleUrls: ['./side-effect-send-notification.component.scss'],
    standalone: false
})
export class SideEffectSendNotificationComponent {
    groups: Group[];
    notificationLevels = Object.values(SystemNotificationLevel);
    hasExternalGroup: boolean = false;
    notificationTypes: Observable<DomainValue[]>;

    constructor(
        public _groupService: GroupService,
        public _domainService: DomainDefinitionService,
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        if (!this.data.configuration)
            this.data.configuration = defaultSideEffectConfig();

        this._groupService.get({ stubs: true })
            .subscribe(groups => {
                this.groups = (groups as any[]).filter(x => x.active);
                //rebuild references so that the select can work with objects
                if (this.data.configuration.groups) {
                    let temp = [];

                    this.data.configuration.groups.forEach(x => {
                        let existingReference = this.groups.find(z => z.id === x.id);

                        if (existingReference)
                            temp.push(existingReference);
                    });

                    this.setGroups(temp);
                }
            });

        this.notificationTypes = this._domainService.getValues("SystemNotificationType").pipe(map(vs => {
            return vs.map(v => mapDomainToDomainValue(v));
        }));
    }

    setGroups(groups: Group[]) {
        this.hasExternalGroup = !!groups.find(x => x.groupType.toLocaleLowerCase() === "external");
        if (!this.hasExternalGroup)
            this.data.configuration.targetOrganization = null;

        this.data.configuration.groups = groups;
    }
}

function mapDomainToDomainValue(v) {
    return {
        value: v.Code,
        displayName: v.Definition
    } as DomainValue;
}

function defaultSideEffectConfig(): SendNotificationConfig {
    return {
        groups: [],
        description: { name: 'Description', ruleId: genId() } as Rule,
        targetOrganization: { name: 'Organization Id', ruleId: genId() } as Rule,
        redirectUrl: { name: 'Redirection Url', ruleId: genId() } as Rule,
        flowId: { name: 'Flow Id', ruleId: genId() } as Rule,
        workItemId: { name: 'Workorder Id', ruleId: genId() } as Rule,
        level: SystemNotificationLevel.Information,
        type: "General"
    };
}

export interface SendNotificationConfig {
    groups: string[],
    level: SystemNotificationLevel,
    description: Rule,
    type: string,
    targetOrganization: Rule,
    redirectUrl: Rule,
    flowId: Rule,
    workItemId: Rule
}
